var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "27px",
    viewBox: "0 0 43 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/social/people_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,20.625 C33.1125,20.625 35.60625,18.1125 35.60625,15 C35.60625,11.8875 33.1125,9.375 30,9.375 C26.8875,9.375 24.375,11.8875 24.375,15 C24.375,18.1125 26.8875,20.625 30,20.625 Z M15,20.625 C18.1125,20.625 20.60625,18.1125 20.60625,15 C20.60625,11.8875 18.1125,9.375 15,9.375 C11.8875,9.375 9.375,11.8875 9.375,15 C9.375,18.1125 11.8875,20.625 15,20.625 Z M15,24.375 C10.63125,24.375 1.875,26.56875 1.875,30.9375 L1.875,35.625 L28.125,35.625 L28.125,30.9375 C28.125,26.56875 19.36875,24.375 15,24.375 Z M30,24.375 C29.45625,24.375 28.8375,24.4125 28.18125,24.46875 C30.35625,26.04375 31.875,28.1625 31.875,30.9375 L31.875,35.625 L43.125,35.625 L43.125,30.9375 C43.125,26.56875 34.36875,24.375 30,24.375 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_Asia_B2C_Desktop_Quote_1",
    transform: "translate(-522.000000, -409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(502.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/people_24px",
    transform: "translate(19.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#1D4FBB",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.e4cf65369c66811ca704f95a7c024c67.svg";
export { ForwardRef as ReactComponent };